<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="">
            Leaderboard
          </h4>
          <h6 style="font-style:italics">
            Challenge yourself, beat the best!
          </h6>
          <h6 class="mt-3" style="font-style:italics">
            Your Alltime QT Points is <strong>{{ details.qt_points }} QT{{ details.qt_points > 1 ? "s" : "" }}</strong>
          </h6>
          <h6 style="font-style:italics">
            QT Points are calculated from each practice test you take. Score
            higher in tests to have more QTs
          </h6>
          
        </b-col>
      </b-row>

      <b-row>
        <!-- <b-col class="m-0 p-0">
          <h4 class="text-center fhe p-3 mt-7">
            leaderboard <span class="smh">(Coming Soon)</span>
          </h4>

          <div class="points-div">
            <p style="font-size: 30px; font-weight: bold;">Congrats!</p>

            <p style="font-size: 20px">You have</p>
            <p style="font-size: 60px; font-weight: bold;" class="point-value">
              {{ details.qt_points }} QT{{ details.qt_points > 1 ? "s" : "" }}
            </p>
            <p style="font-size: 20px">in your QT Chest</p>

            <img src="@/assets/goldenTrophy2.png" class="trophy-image" />

            <p class="point-info text-center">
              Practice more often and get better scores to get more QT Points
              and Climb up the Leaderboard to win amazing prizes
            </p>
          </div>
        </b-col> -->
      </b-row>

      <b-row>
        <b-col>

          <div>
            <h4 class="text-center fhe p-3 mt-7">
              {{ leaderboardDetails?.current_month }} Leaderboard
            </h4>

            <b-skeleton-wrapper class="text-center mt-3" :loading="loading">
              <template #loading>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
                <b-skeleton height="50px" width="100%"></b-skeleton>
              </template>
            </b-skeleton-wrapper>

            <div v-if="!loading">
              <board-card
                v-for="(leaderboard, index) in leaderboardTable"
                :key="index"
                :keys="index"
                :page="pages"
                :perPage="intervalnum"
                :leaderboard="leaderboard"
              ></board-card>
            </div>
          </div>


          <paginater
              :intervalnum="intervalnum"
              :pages="pages"
              :meta="meta"
              :endnum="meta?.perPage * pages"
              :endss="endss"
              :datalength="endss"
              @paginator="newPage"
              @changeInterval="effectInterval"
          ></paginater>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import store from "@/store"
import { mapState, mapActions } from "vuex";

import boardCard from "@/components/boardCard";
import Paginater from "@/components/Paginater";

export default {
  components: {
    boardCard,
    Paginater
  },
  mounted(){
    this.fetchLeaderboard();
  },
  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      pages: 1,
      isActivea: true,
      isActiveb: false,
      activeone: 0,
      leaderboardDetails: {},
      leaderboardTable : [],
      meta : {},
      loading: false
    };
  },
  watch:{
    pages(){
      this.fetchLeaderboard();
    },
    intervalnum(){
      this.fetchLeaderboard();
    }
  },  
  methods: {
    ...mapActions("dashboard", ["retrieveLeaderboard"]),
    async fetchLeaderboard() {

      this.loading = true;

      try {
        const response = await this.retrieveLeaderboard(`page=${this.pages}&perPage=${this.intervalnum}`);
        this.leaderboardDetails = response.data.data;
        this.leaderboardTable = response?.data?.data.current_board
        this.meta = response.data.meta

        console.log(response.data)

        this.loading = false;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false
      }
    },
    makeactive(index) {
      //alert(`Active is now ${index}`)
      this.activeone = index;

      return index;
    },
    newPage(page) {
      this.pages = page;
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      plan: state => state.loginmaster.details.plan
    }),

    endss() {
      let end = this.meta?.total;
      return end;
    },
  }
};
</script>

<style scoped>
.fhe {
  background-color: #00377b;
  color: white;
  border-radius: 20px 20px 0px 0px;
  font-weight: bold;
  margin-top: 30px;
}

.competimg {
  width: 100%;
  height: 30rem;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
.tab-lead {
  padding: 2px;
  font-size: 1.1rem;
  cursor: pointer;
  width: 50%;
}
.active-class {
  border-bottom: 5px solid #00377b;
}
.tabdiv {
  display: flex;
}

.points-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  padding: 20px;
}

.point-info {
  font-size: 20px;
}

.smh {
  font-size: 16px;
}

.coming-soon {
}

.trophy-image {
  transform-origin: center;
  animation: rollCup 5s ease-in-out forwards;
}

@keyframes rollCup {
  0% {
    transform: rotate(0deg) scale(1);
  }
  80% {
    transform: rotate(1800deg) scale(2); /* Rotates 5 times (360*5=1800) and scales up */
  }

  95% {
    transform: rotate(0deg) scale(4); /* Returns to normal position and size */
  }

  100% {
    transform: rotate(0deg) scale(1); /* Returns to normal position and size */
  }
}

@media (max-width: 768px) {
  .competimg {
    height: 30rem;
  }

  .point-info {
    font-size: 14px;
  }
}
@media screen and (min-width: 768px) {
  .tab-lead {
    font-size: 2rem;
  }
}
</style>
